export default __webpack_public_path__ + "static/media/Error-person.046c9fec.svg";